<div class="widget widget-search">
    <input
        type="search"
        [name]="name"
        [placeholder]="placeholder"
        (keyup.enter)="onTermChange()"
        (keyup)="onKeyPress()"
        [(ngModel)]="term"
    />
    <i class="widget-icon i i-search"></i>
    <a *ngIf="resetable && term" class="widget-clear" (click)="onClearClick()"><i class="i i-cross-circle"></i></a>
</div>
